export default function Hero() {
  const scrollToRegister = () => {
    const element = document.getElementById('register');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="relative w-full h-full">
          <img
            src="https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/98e66e26d8b5346da8b4fd649c9563be.jpeg"
            alt="Cherokee Warriors Field"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Side - Main Message */}
          <div className="lg:col-span-3 flex flex-col items-center lg:items-start">
            <div className="space-y-4">
              <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl text-white leading-none tracking-tight">
                <span className="block text-center lg:text-left">BUILD</span>
                <span className="block text-center lg:text-left lg:ml-8">CHARACTER</span>
              </h1>
              <h2 className="font-display text-6xl sm:text-7xl lg:text-8xl text-white leading-none tracking-tight">
                <span className="block text-center lg:text-left lg:ml-16">MAKE</span>
                <span className="block text-center lg:text-left lg:ml-24">MEMORIES</span>
              </h2>
              <h3 className="font-display text-6xl sm:text-7xl lg:text-8xl text-warrior-red leading-none tracking-tight">
                <span
                  className="block text-center lg:text-left lg:ml-32"
                  style={{ WebkitTextStroke: '1px white' }}
                >cheer &amp; play ball</span>
              </h3>
            </div>
          </div>

          {/* Right Side - Registration Info */}
          <div className="lg:col-span-2">
            <div className="bg-warrior-black/90 backdrop-blur-sm rounded-2xl p-8 lg:p-10 shadow-2xl">
              <div className="space-y-6">
                <div className="inline-block bg-warrior-red px-4 py-2 rounded-full">
                  <span className="font-sans text-sm font-bold text-white tracking-wide">2026 FALL SEASON</span>
                </div>
                
                <h4 className="font-display text-4xl text-white leading-tight">
                  Registration now open!
                </h4>
                
                <p className="font-sans text-base text-gray-300 leading-relaxed">
                  Join the Cherokee Warriors family! Our K-5 football and cheer programs focus on building character, teamwork, and confidence in a safe, supportive environment.&nbsp;
                </p>
                
                <div className="space-y-3 pt-4">
                  <a
                    href="https://cobbfootball.leagueapps.com/clubteams/4926021-2026-cherokee-youth-football--cheerleading"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-warrior-red text-white font-sans font-bold text-base px-8 py-4 rounded-lg hover:bg-red-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2"
                  >
                    <span>START REGISTRATION</span>
                    <i className="ri-arrow-right-line text-xl"></i>
                  </a>
                  
                  <button 
                    onClick={() => {
                      const element = document.getElementById('programs');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="w-full bg-transparent border-2 border-white text-white font-sans font-bold text-base px-8 py-4 rounded-lg hover:bg-white hover:text-warrior-black transition-all whitespace-nowrap cursor-pointer"
                  >
                    LEARN MORE
                  </button>

                  <a
                    href="https://form.jotform.com/253468410435052"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-transparent border-2 border-warrior-red text-warrior-red font-sans font-bold text-base px-8 py-4 rounded-lg hover:bg-warrior-red hover:text-white transition-all whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2"
                  >
                    <i className="ri-mail-line text-xl"></i>
                    <span>GET EMAIL UPDATES</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white"></i>
        </div>
      </div>
    </section>
  );
}